import { ApiError } from '../../../../lib/apiError';
import type { RoutingFileApi } from '../routingApi';

/**
 * Files each picked file against a record that now exists — ONE request per file, in order.
 *
 * **After the record, never with it.** The record is created first so the files have something to
 * be filed against; a file that fails does not undo the record, because resubmitting the form
 * would then encode the same letter twice. What failed is RETURNED, and the form reports it rather
 * than swallowing it — the reader files it again from the record's Preview tab.
 *
 * `onProgress` reports the real figure across the whole batch, because `apiUpload` measures it.
 */
export async function fileAll(
  /** Only `attach` is called — a dispatch's files and a forward's go through the same loop. */
  api: Pick<RoutingFileApi, 'attach'>,
  recordId: string,
  files: File[],
  onProgress: (percent: number) => void,
): Promise<{ name: string; reason: string }[]> {
  const failed: { name: string; reason: string }[] = [];

  for (const [index, file] of files.entries()) {
    try {
      await api.attach(recordId, file, (percent) =>
        onProgress(Math.floor(((index + percent / 100) / files.length) * 100)),
      );
    } catch (caught) {
      failed.push({
        name: file.name,
        reason: caught instanceof ApiError ? caught.message : 'It could not be filed.',
      });
    }
  }

  onProgress(100);

  return failed;
}
